<template>
  <form>
    <div
      class="modal-card"
      style="width: auto">
      <header class="modal-card-head">
        <p
          class="modal-card-title">
          <translate>Skapa Ny Tävlingsdag</translate>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field
          :label="$gettext('Namn')">
          <b-input
            v-model="name"
            type="string"
            :placeholder="$gettext('Tävlingsdagens namn')"
            required />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          @click="save">
          <translate>Spara</translate>
        </button>
      </footer>
    </div>
  </form>
</template>


<script>
import { dayService } from '../../_services';

export default {
  name: 'NewDay',
  props: {
    competition: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      name: '',
    }
  },
  async created() {
  },
  methods: {
    save: async function(){
      var self = this
      const data =
        {
          competition: self.competition,
          name: self.name,
        }
      await dayService.post(data)
    }
  },
}
</script>
